export interface FamilyMember {
  id: string
  firstName: string
  lastName: string
  role: string
  initials: string
  hasCard: boolean
  photo: string
  canEdit: boolean
}

export interface EditableField {
  id: string
  label: string
  placeholder: string
  requiresProof: boolean
  proofLabel?: string
}

export const editableFields: EditableField[] = [
  {
    id: 'prenom',
    label: 'Prénom',
    placeholder: 'Charlotte',
    requiresProof: true,
    proofLabel: 'Certificat de naissance ou pièce d’identité',
  },
  {
    id: 'nom',
    label: 'Nom de famille',
    placeholder: 'Bouchard',
    requiresProof: true,
    proofLabel: 'Pièce d’identité officielle',
  },
  { id: 'genre', label: 'Genre', placeholder: 'Femme', requiresProof: false },
  { id: 'photo', label: 'Photo de la carte', placeholder: 'Nouvelle photo', requiresProof: false },
  {
    id: 'adresse',
    label: 'Adresse',
    placeholder: '214, rue Saint-Frédéric, Windsor',
    requiresProof: false,
    proofLabel: 'Preuve de résidence (bail, compte de taxes, permis de conduire)',
  },
]

export const verifiedAddresses = [
  { id: 'saint-frederic', label: '214, rue Saint-Frédéric, Windsor', note: 'Adresse principale · vérifiée' },
  { id: 'du-moulin', label: '78, rue du Moulin, Windsor', note: 'Deuxième propriété · vérifiée' },
]

export const memberValues: Record<string, Record<string, string>> = {
  charlotte: {
    prenom: 'Charlotte',
    nom: 'Bouchard',
    genre: 'Femme',
    photo: 'Photo actuelle',
    adresse: '214, rue Saint-Frédéric, Windsor',
  },
  marc: {
    prenom: 'Marc',
    nom: 'Bélanger',
    genre: 'Homme',
    photo: 'Photo actuelle',
    adresse: '214, rue Saint-Frédéric, Windsor',
  },
  emma: {
    prenom: 'Emma',
    nom: 'Bouchard',
    genre: 'Femme',
    photo: 'Photo actuelle',
    adresse: '214, rue Saint-Frédéric, Windsor',
  },
}

export const citizen = {
  firstName: 'Charlotte',
  lastName: 'Bouchard',
  initials: 'CB',
  city: 'Windsor',
}

export const cardCredentials = ['Résident', 'Piscine', 'Bibliothèque', 'Loisirs']

export interface WalletCard {
  id: string
  label: string
  number: string
  badge: string
  note: string
}

export const walletCards: WalletCard[] = [
  {
    id: 'citoyenne',
    label: 'Carte numérique',
    number: '0040327823',
    badge: 'Résident',
    note: 'Accès au Centre sportif J.A. Lemay valide jusqu’au 30 septembre',
  },
  {
    id: 'loisirs',
    label: 'Loisirs',
    number: '0093612477',
    badge: 'Résident',
    note: 'Natation d’Emma · samedi 10 h',
  },
  {
    id: 'bibliotheque',
    label: 'Bibliothèque',
    number: '0071845209',
    badge: 'Résident',
    note: '2 documents à rapporter avant le 12 septembre',
  },
]

export const familyMembers: FamilyMember[] = [
  {
    id: 'charlotte',
    firstName: 'Charlotte',
    lastName: 'Bouchard',
    role: 'Titulaire',
    initials: 'CB',
    hasCard: true,
    photo: 'https://cdn.magicpatterns.com/patterns/generated-images/3ed6e46d-2ab5-4f53-8f0e-9919328bc5b5.jpg',
    canEdit: true,
  },
  {
    id: 'marc',
    firstName: 'Marc',
    lastName: 'Bélanger',
    role: 'Conjoint',
    initials: 'MB',
    hasCard: true,
    photo: 'https://cdn.magicpatterns.com/patterns/generated-images/6d75bf83-2bf9-4f1d-8912-8fecf05ffaa8.jpg',
    canEdit: false,
  },
  {
    id: 'emma',
    firstName: 'Emma',
    lastName: 'Bouchard',
    role: 'Enfant',
    initials: 'EB',
    hasCard: false,
    photo: 'https://cdn.magicpatterns.com/patterns/generated-images/34fafd9b-c877-4154-8e6b-5e158dfa521f.jpg',
    canEdit: true,
  },
]
